import authActions from "./actions";

const initialState = {
    ProfileSummaryDetails:[],
    menuDetails:[],
    candidateTokenDetails: null,
    profileRegistrationActiveTab: null,
    otpVerificationCount:null,
    AadharInitiate:null,
    otpVerificationCountExceed:false,
    forgotPass_MobileVerification: {
        validated: false
    },
    tempCandidateDetails:[],
    MobileVerifiedDetails:null,
     otpVerified: false,
    apparMandatoryDialog: false,
    callbackApiDetails:null,
    mobileVerifiedLoaded: false
};

const authReducer = (state = initialState, action) => {
    switch (action.type) {
        case authActions.SET_PROFILE_SUMMARY:
            return{
                ...state,
                ProfileSummaryDetails: action.payload, 
            }
        case authActions.SET_CALL_BACK_API_FOR_AADHAR:
            return{
                ...state,
                callbackApiDetails: action.payload, 
            }
            case authActions.SET_MOBILE_VERIFIED:
            return{
                ...state,
                MobileVerifiedDetails: action.payload, 
                mobileVerifiedLoaded: true
            }
        case authActions.SET_AADHAR_INITIATE:
            return{
                ...state,
                AadharInitiate: action.payload, 
            }
            case authActions.SET_OTP_VERIFIED:
      return {
        ...state,
        otpVerified: action.payload,
      };
            case authActions.SET_ALL_MENU:
            return{
                ...state,
                menuDetails: action.payload, 
            }
        case authActions.SET_CANDIDATE_TOKEN_DETAILS:
            return {
                ...state,
                candidateTokenDetails: action.payload
            }
        case authActions.SET_PROFILE_REGISTRATION_ACTIVE_TAB:
            return {
                ...state,
                profileRegistrationActiveTab: action.payload
            }
            case authActions.SET_OTP_VERIFICATION_COUNT:
                return {
                    ...state,
                    otpVerificationCount: action.payload
                }
            case authActions.SET_OTP_VERIFICATION_COUNT_EXCEED:
                return {
                    ...state,
                    otpVerificationCountExceed: action.payload
                }
        case authActions.FORGOTPASSWORD_MOBILEVERIFICATION:
            return {
                ...state,
                forgotPass_MobileVerification: action.payload
            }
        case authActions.SET_TEMP_CANDIDATE_DETAILS:
            return{
                ...state,
                tempCandidateDetails: action.payload
            } 
        case authActions.SET_APPAR_MANDATORY_DIALOG:
            return{
                ...state,
                apparMandatoryDialog : action.payload
            }
        default:
            return state;
    };
};

export default authReducer;